import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import { GroupSet } from '@Types';

export const listGroupSets = createAction(addNamespace('groupSets/list'));

export const listGroupSetsResolved = createAction<GroupSet[]>(addNamespace('groupSets/list/resolved'));

export const getGroupSetAction = createAction<string>(addNamespace('groupSet/get'));

export const getGroupSetResolved = createAction<GroupSet>(addNamespace('groupSets/get/resolved'));
